import React from 'react';
import { AdditionalModalState } from './additionalModalState/AdditionalModalState';
import { EditForm } from './components/EditForm';

interface IProps {
	onFailureEvent?: () => void;
	onCloseModal: () => void;
	onShowError: () => void;
}

export const AdditionalModal: React.FC<IProps> = ({ onFailureEvent, onCloseModal, onShowError }) => {
	return (
		<AdditionalModalState>
			<EditForm onCloseModal={onCloseModal} onFailureEvent={onFailureEvent} onShowError={onShowError} />
		</AdditionalModalState>
	);
};
